module.exports = __webpack_public_path__ + "static/media/CHAWCAG_MENU-normal.d3cd3340.png";